import { defineStore } from "pinia";

export const configuratorOpenState = defineStore("configuratorState", {
  state: () => ({
    open: false,
    lng: "en-gb",
    model: false,
  }),
  actions: {
    setOpen(open: boolean) {
      this.open = open;
    },
    setLang(lng: string) {
      this.lng = lng;
    },
    setOpenModal(open: boolean) {
      this.model = open;
    },
  },
});
